export default __webpack_public_path__ + "static/media/logo.d8591730.svg";